import { Icon, IconsEnum } from 'components/Icons';
import { AnchorLink } from 'components/anchorLink';
import { useGetLabelByKey } from 'hooks/useLingUI';
import React, { useCallback } from 'react';
import styles from './GameDetailSkillGamesInfo.module.scss';
export type GameDetailSkillGamesInfoProps = {
  coverImageCaption?: string;
  promo?: { dataInizio: string; dataFine: string; url: string | null }; // TODO aggiornare con libreria date-fns
};
export const GameDetailSkillGamesInfo = ({ coverImageCaption, promo }: GameDetailSkillGamesInfoProps) => {
  const labelScopri = useGetLabelByKey('scopri-promo-bar')!;
  const labelPromo = useGetLabelByKey('promo-valida')!;
  let dataInizio = '';
  let dataFine = '';
  // TODO modificare con il formato libreria date-fns
  const formatDate = useCallback((data: string) => {
    let objectDate = new Date(data);
    let day = objectDate.getDate();
    let month = objectDate.getMonth() + 1;
    let year = objectDate.getFullYear();
    return day + '/' + month + '/' + year;
  }, []);

  if (promo) {
    dataInizio = formatDate(promo.dataInizio);
    dataFine = formatDate(promo.dataFine);
  }
  return (
    <React.Fragment>
      {coverImageCaption && <p className={styles.imageCaption}> {coverImageCaption} </p>}

      {/** possibile componente promobar */}
      {promo && (
        <div className={styles.promoBar}>
          <div className={styles.promoDetails}>
            <div className={styles.iconContainer}>
              <Icon iconId={IconsEnum.BONUS} className={styles.icon} color="var(--color-on-bg-primary)" />
            </div>
            <div className={styles.detailsContainer}>
              <p className={styles.promoName}>{labelPromo}</p>
              <p className={styles.deadline}>
                Dal {dataInizio} al {dataFine}
              </p>
            </div>
          </div>
          <AnchorLink className={styles.link} href={`${promo.url}`}>
            <a>{labelScopri}</a>
          </AnchorLink>
        </div>
      )}
    </React.Fragment>
  );
};
